import { ChipAwareMarkdown } from '@/markdown/chips';
import type { SafetyFollowupNoticeSection } from '@/types/chat';

export function SafetyFollowupNoticeView({
  section,
}: {
  section: SafetyFollowupNoticeSection;
}): JSX.Element {
  return (
    <section
      className="tw-rounded-xl tw-border tw-border-cal-warning tw-bg-cal-warning-bg tw-px-3 tw-py-2.5 tw-text-[13.5px] tw-font-medium tw-leading-relaxed tw-text-cal-ink"
      role="alert"
    >
      <ChipAwareMarkdown
        source={section.body_md}
      />
    </section>
  );
}
